<template>
    <main class="static-page max-width-container">
        <h1>Cookies</h1>
        <p>
            The site sets three cookies of its own, all of which it needs to
            work. A few outside services can set cookies too, but only if you
            allow external content. None of it is for analytics or advertising.
        </p>

        <h2>Always set</h2>
        <p>
            These can't be turned off. Without them you couldn't stay logged in,
            and the site would forget your cookie choice.
        </p>
        <table class="cookie-table">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Purpose</th>
                    <th>Lifetime</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Session cookie</td>
                    <td>Keeps you signed in.</td>
                    <td>
                        Until you log out, or about 2 hours after you last did
                        anything
                    </td>
                </tr>
                <tr>
                    <td>XSRF-TOKEN</td>
                    <td>
                        Stops other sites from sending requests as you
                        (cross-site request forgery).
                    </td>
                    <td>Same as the session cookie</td>
                </tr>
                <tr>
                    <td>tt_consent</td>
                    <td>Remembers what you picked in the cookie banner.</td>
                    <td>12 months</td>
                </tr>
            </tbody>
        </table>

        <h2>External content (only if you allow it)</h2>
        <p>
            Some photos and map tiles come from other services. If you click
            "Allow external content" in the cookie banner, your browser fetches
            them directly, and these services may set cookies of their own:
        </p>
        <table class="cookie-table">
            <thead>
                <tr>
                    <th>Service</th>
                    <th>Used for</th>
                    <th>Cookies they may set</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Pexels</td>
                    <td>Trip inspiration photos</td>
                    <td>__cf_bm, _cfuvid (Cloudflare, up to 30 minutes)</td>
                </tr>
                <tr>
                    <td>Wikipedia</td>
                    <td>Location and bucket-list item photos</td>
                    <td>WMF-Uniq (up to 1 year), WMF-Last-Access</td>
                </tr>
                <tr>
                    <td>MapTiler</td>
                    <td>Satellite map tiles</td>
                    <td>_cfuvid (Cloudflare, browser session)</td>
                </tr>
            </tbody>
        </table>
        <p>
            Until you allow it, photos show a placeholder instead. Clicking it
            allows all external images and maps, not just that one. The
            satellite map stays on the standard map until then. You can change
            your mind any time under "Cookie settings" in the footer.
        </p>
        <Bttn id="open-cookie-settings" @click="consentStore.open()"
            >Cookie settings</Bttn
        >

        <h2>Also worth knowing</h2>
        <p>
            The standard map always comes from OpenStreetMap. It doesn't set
            cookies, but it does see your IP address, which the
            <router-link to="/privacy">privacy policy</router-link> covers.
            Registration and the contact form (when you're logged out) use
            Cloudflare Turnstile, which checks your browser for bot signals and
            doesn't set cookies either. There's no localStorage use, no
            analytics and no ads. Fonts and icons are served from this site, not
            from a third party.
        </p>

        <p>
            More on how your data is handled is in the
            <router-link to="/privacy">privacy policy</router-link>. Questions
            go through the
            <router-link to="/contact">contact form</router-link>.
        </p>
    </main>
</template>

<script>
import { useConsentStore } from "js/stores/consentStore.js";

export default {
    name: "Cookies",
    data() {
        return {
            consentStore: useConsentStore(),
        };
    },
};
</script>
